import { http } from '@/base/utils/http-compat'
import { HTTP_STATUS } from '../const/http.const'
import { Raven } from '@/base/utils/raven-compat'

const OPTIONS = {
  credentials: 'include',
}

function isResponseValidString(response) {
  return typeof response.body === 'string'
}
function isResponseValidObject(response) {
  return typeof response.body === 'object'
}
function supportServerErrors(error) {
  const internalErrorsList = [HTTP_STATUS.INTERNAL_SERVER_ERROR, HTTP_STATUS.SERVICE_UNAVAILABLE]

  if (internalErrorsList.includes(error.status)) {
    Raven.captureMessage('api.class.js supportServerErrors Method response error', {
      extra: error,
    })
  }
}

export class ApiClass {
  getExternal(url, options = {}) {
    Object.assign(options, OPTIONS)
    return http.get(url, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  get(endpoint, options = {}) {
    Object.assign(options, OPTIONS)
    const url = ApiClass.getBackendUrl(endpoint)
    return http.get(url, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  getAds(endpoint, options = {}) {
    Object.assign(options, {
      credentials: false,
    })
    const url = ApiClass.getAdServerUrl(endpoint)
    return http.get(url, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  post(endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS)
    const url = ApiClass.getBackendUrl(endpoint)
    return http.post(url, data, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  postCards(endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS, { credentials: false })
    const url = ApiClass.getCardsBackendUrl(endpoint)
    return http.post(url, data, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  postAdForm(endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS, { credentials: false })
    const url = ApiClass.getAdFormUrl(endpoint)
    return http.post(url, data, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  postSyncHub(endpoint, data = {}, options = {}) {
    Object.assign(options, OPTIONS, { credentials: false })
    const url = ApiClass.getSyncHubUrl(endpoint)
    return http.post(url, data, options).then(
      (response) => {
        if (isResponseValidString(response) || isResponseValidObject(response)) {
          return Promise.resolve(response)
        }
        return Promise.reject(response)
      },
      (error) => {
        supportServerErrors(error)
        return Promise.reject(error)
      }
    )
  }

  static getBackendUrl(endpoint) {
    if (import.meta.env.DEV) {
      return endpoint
    }

    const apiUrl = import.meta.env.VITE_APP_API
    return apiUrl ? `${apiUrl}${endpoint}` : endpoint
  }

  static getCardsBackendUrl(endpoint) {
    if (import.meta.env.DEV) {
      return endpoint
    }

    return import.meta.env.VITE_APP_CARDS_API + endpoint
  }

  static getAdServerUrl(endpoint) {
    if (import.meta.env.DEV) {
      return endpoint
    }

    return import.meta.env.VITE_APP_ADS_API + endpoint
  }

  static getAdFormUrl(endpoint) {
    if (import.meta.env.DEV) {
      return endpoint
    }

    return import.meta.env.VITE_APP_ADFORM_URL + endpoint
  }

  static getSyncHubUrl(endpoint) {
    const apiUrl = import.meta.env.VITE_APP_SYNCHUB_API
    return apiUrl ? `${apiUrl}${endpoint}` : endpoint
  }
}

export const apiClass = new ApiClass()
